import { IOrderInput } from "@/interfaces/order.interfaces";
import { OrderStatus } from "@/types/order.types";

function useOrderStatusLogic(order: IOrderInput | null, isEditing: boolean) {
  // Se não estiver no modo de edição, o botão não deve ser desabilitado
  if (!isEditing) return { disabledButton: false };

  const orderStatus = order?.orderStatus;
  const salesChannel = order?.salesChannel?.toUpperCase();
  const isTalk2BuyChannel = salesChannel === "TALK2BUY";

  // Conforme orders-status.md: PUT só é permitido quando status atual é W (Waiting) ou E (Error)
  const canUpdate = orderStatus === OrderStatus.Waiting || orderStatus === OrderStatus.Error;

  return { disabledButton: !canUpdate, isTalk2BuyChannel };
}

export default useOrderStatusLogic;
